import { render } from "./Board.vue?vue&type=template&id=4c894e63"
import script from "./Board.vue?vue&type=script&lang=js"
export * from "./Board.vue?vue&type=script&lang=js"

import "./Board.vue?vue&type=style&index=0&id=4c894e63&lang=scss"

import exportComponent from "/Users/boris/Developer/me/git/retro-puzzle/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__